/**
 * Spec 055 (D14): quando o servidor não consegue manter a reserva do grupo de uma classe tarifária, ele
 * tira do carrinho TODAS as poltronas daquele grupo e devolve quais saíram. O corpo do erro NÃO traz o
 * código (`Cart.GroupReleased`) — é a presença desta lista que identifica o caso.
 * @param {object} error O erro do axios
 * @return {Array<{reservationId?: string, seatId?: string, seatNumber?: string}>} poltronas liberadas
 */
export function releasedSeatsFrom(error) {
	const body = error && error.response && error.response.data
	const released = body && body.data && body.data.releasedSeats

	return Array.isArray(released) ? released : []
}
